import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_LEAVES_REQUEST = "FETCH_LEAVES_REQUEST";
export const FETCH_LEAVES_SUCCESS = "FETCH_LEAVES_SUCCESS";
export const FETCH_LEAVES_FAILURE = "FETCH_LEAVES_FAILURE";

export const UPDATE_LEAVE_STATUS_REQUEST = "UPDATE_LEAVE_STATUS_REQUEST";
export const UPDATE_LEAVE_STATUS_SUCCESS = "UPDATE_LEAVE_STATUS_SUCCESS";
export const UPDATE_LEAVE_STATUS_FAILURE = "UPDATE_LEAVE_STATUS_FAILURE";

export const FETCH_USER_LEAVES_REQUEST = "FETCH_USER_LEAVES_REQUEST";
export const FETCH_USER_LEAVES_SUCCESS = "FETCH_USER_LEAVES_SUCCESS";
export const FETCH_USER_LEAVES_FAILURE = "FETCH_USER_LEAVES_FAILURE";

export const fetchUserLeavesRequest = () => ({
  type: FETCH_USER_LEAVES_REQUEST,
});

export const fetchUserLeavesSuccess = (users, pagination) => ({
  type: FETCH_USER_LEAVES_SUCCESS,
  payload: { users, pagination },
});

export const fetchUserLeavesFailure = (error) => ({
  type: FETCH_USER_LEAVES_FAILURE,
  payload: error,
});

// Action Creators
export const fetchLeavesRequest = () => ({ type: FETCH_LEAVES_REQUEST });
export const fetchLeavesSuccess = (leaves) => ({
  type: FETCH_LEAVES_SUCCESS,
  payload: leaves,
});
export const fetchLeavesFailure = (error) => ({
  type: FETCH_LEAVES_FAILURE,
  payload: error,
});

// Thunk — Get all leaves
export const fetchLeaves = () => {
  return async (dispatch) => {
    dispatch(fetchLeavesRequest());
    const token = localStorage.getItem("token");

    try {
      const res = await axios.get(`${BASE_URL}/v1/api/admin/getAllLeaves`, {
        headers: { authorization: token },
      });

      // Ensure correct array from API
      dispatch(fetchLeavesSuccess(res.data.data || []));
    } catch (err) {
      const errorMsg = err?.response?.data?.meta?.message || err.message;
      dispatch(fetchLeavesFailure(errorMsg));
    }
  };
};

// Thunk — Update leave status
export const updateLeaveStatus = (id, status, leaves_status) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_LEAVE_STATUS_REQUEST });
    const token = localStorage.getItem("token");

    try {
      await axios.post(
        `${BASE_URL}/v1/api/admin/updateLeaveStatus`,
        { id, status, leaves_status },
        { headers: { authorization: token } }
      );

      dispatch({ type: UPDATE_LEAVE_STATUS_SUCCESS });
      dispatch(fetchLeaves()); // Refresh list
    } catch (err) {
      const errorMsg = err?.response?.data?.meta?.message || err.message;
      dispatch({ type: UPDATE_LEAVE_STATUS_FAILURE, payload: errorMsg });
    }
  };
};


// ✅ Users remaining leaves
export const fetchUsersRemainingLeaves = (page = 1, limit = 10) => async (dispatch) => {
  dispatch(fetchUserLeavesRequest());
  const token = localStorage.getItem("token");

  try {
    const res = await axios.get(
      `${BASE_URL}/v1/api/users-remaining-leaves?page=${page}&limit=${limit}`,
      { headers: { authorization: token } }
    );

    dispatch(
      fetchUserLeavesSuccess(
        res.data.data || [],
        res.data.meta.pagination || {}
      )
    );
  } catch (err) {
    dispatch(fetchUserLeavesFailure(
      err?.response?.data?.meta?.message || err.message
    ));
  }
};